module.exports = __webpack_public_path__ + "img/favicon.5a0c77a8815cfcc67c710199054a55c6.ico";


//////////////////
// WEBPACK FOOTER
// /~/@buzzfeed/buzzblocks/img/favicon.ico
// module id = 42
// module chunks = 1